import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {GjeldendeTidssone, Tidssoneinformasjon} from "../tjenester/i18n/GjeldendeTidssone";
import {ZonedDateTimeSerialisert} from "../tjenester/ressurser/generertNg2HttpKlient";
import {lesDateEllerZonedDateTimeSerialisert, plainDateFraZonedDateTime} from "../støttefunksjoner/temporal";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import ZonedDateTime = Temporal.ZonedDateTime;
import PlainDate = Temporal.PlainDate;

/**
 * Leser angitt verdi som ZonedDateTime og konverterer så denne til PlainDate i brukers tidssone.
 * Angitt dato kan være av typen ZonedDateTime, ZonedDateTimeSerialisert eller Date.
 */
@Pipe({name: 'zoneddatetimeSomPlaindate', pure: true, standalone: true})
export class ZonedDateTimeSomPlainDatePipe implements PipeTransform {
    constructor(private gjeldendeTidssone: GjeldendeTidssone) {
    }

    transform(datoOgKlokkeslett: ZonedDateTime | ZonedDateTimeSerialisert | Date | null, tidssone:Tidssoneinformasjon = this.gjeldendeTidssone.brukersTidssone()): PlainDate | null {
        const zonedDateTime = (datoOgKlokkeslett instanceof ZonedDateTime) ? datoOgKlokkeslett : lesDateEllerZonedDateTimeSerialisert(datoOgKlokkeslett);
        if (erNil(zonedDateTime)) return null;
        return plainDateFraZonedDateTime(zonedDateTime, tidssone);
    }
}
